import { render, staticRenderFns } from "./SwaySpectrumChartCard.vue?vue&type=template&id=0fbf1194&scoped=true&"
import script from "./SwaySpectrumChartCard.vue?vue&type=script&lang=js&"
export * from "./SwaySpectrumChartCard.vue?vue&type=script&lang=js&"
import style0 from "./SwaySpectrumChartCard.vue?vue&type=style&index=0&id=0fbf1194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf1194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
